import React, { Suspense, lazy } from 'react';

// A reply's markdown (chat-2, 2026-10-30): headings, lists, bold and tables,
// drawn by replyMarkdownRender.js.
//
// That renderer is react-markdown and the parser behind it, about 155 KB of
// script, and it used to sit in the one bundle every visitor parses before
// anything paints, the landing page included, for people who never open the
// chat (2026-10-31). It is now its own chunk, fetched once a chat is on
// screen (preloadMarkdown, called as the chat mounts). Until it arrives, which
// is before a reopened conversation's messages normally do, a reply shows as
// its plain words.
const loadRenderer = () => import('./replyMarkdownRender');
const Renderer = lazy(loadRenderer);

/** Starts fetching the renderer, so it is here before the first reply. */
let preloading = null;
export const preloadMarkdown = () => {
  if (!preloading) preloading = loadRenderer().catch(() => { preloading = null; });
  return preloading;
};

const PlainText = ({ text }) => <div className="ag-md-plain">{text}</div>;

// Parsed once per distinct text. react-markdown re-parses on every render;
// with every message in the list re-rendering on each streamed token, a long
// conversation was re-parsing all of its history dozens of times a second.
// Memoised on the text, only the message that changed parses — the
// streaming one — and the rest are free.
export const Md = React.memo(function Md({ text }) {
  return (
    <Suspense fallback={<PlainText text={text} />}>
      <Renderer text={text} />
    </Suspense>
  );
});
